import { SxProps } from '@mui/material';

const DEFAULT_LINE_HEIGHT = '1.43rem';
const DEFAULT_NUM_LINES = 3;

export const CustomerNotesTypographySx = (
  overflow: boolean,
  expanded: boolean,
  overrideSx: SxProps = {},
  lineHeight: string = DEFAULT_LINE_HEIGHT,
  numLines: number = DEFAULT_NUM_LINES
) => ({
  mr: '16px',
  pr: '1rem',
  lineHeight,
  width: '100%',
  wordWrap: 'break-word',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'break-spaces',
  height: expanded ? 'auto' : `calc(${numLines} * ${lineHeight})`,
  pb: expanded ? lineHeight : '0',
  position: 'relative',
  ...(overflow && {
    ':before': {
      position: 'absolute',
      content: !expanded ? '"..."' : '""',
      bottom: 0,
      right: '5rem',
      zIndex: 999,
      paddingLeft: '0.3rem',
      background: 'white',
    },
    '.show-more-link': {
      content: '" Show more"',
      position: 'absolute',
      ...(!expanded ? { right: 0 } : { left: 0 }),
      bottom: '0',
      background: 'white',
      zIndex: 999,
      fontWeight: 'bold',
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  }),
  ...overrideSx,
});
